import { Injectable } from '@angular/core';
import { User } from '@api-ui-app/src/app/shared/lib/user';

declare global {
  interface Window {
    hj: any;
  }
}

@Injectable({
  providedIn: 'root',
})
export class HotjarService {
  setupUserProperties(user: User): void {
    if (!window.hj) {
      return;
    }

    const userId = user.clientId;
    const userProperties = {
      clientId: userId,
      email: user.email,
      name: `${user.firstName} ${user.lastName}`,
    };

    // Identify user on Hotjar
    window.hj('identify', userId, userProperties);
  }
}
